const pageSection = 'tv';
export const showsOverviewRoute = i18n => ({
  pageId: 'showOverview',
  pageType: 'overview',
  pageSection,
  path: `/${pageSection}/${i18n.t('routes.showOverview')}`,
  remixRoute: 'ShowOverviewPage.remix-route.tsx',
  showScrollTop: true
});